import { openDB } from "idb";

const DB_NAME = "cacheStore"; 

// Function to setup IndexedDB with a dynamic store name
export async function setupDB(storeName) {
    return openDB(DB_NAME, 1, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(storeName)) {
                db.createObjectStore(storeName);
            }
        },
    });
}

// Save data to IndexedDB with a dynamic store name
export async function saveToDB(storeName, key, data) {
    const db = await setupDB(storeName);
    await db.put(storeName, { data, timestamp: Date.now() }, key);
}

// Get data from IndexedDB with expiry check (default 1 hour)
export async function getFromDB(storeName, key, expiry = 3600000) {
    const db = await setupDB(storeName);
    const result = await db.get(storeName, key);

    if (result && Date.now() - result.timestamp < expiry) {
        return result.data; 
    }

    return null; 
}

// Delete a specific key from IndexedDB
export async function deleteFromDB(storeName, key) {
    const db = await setupDB(storeName);
    await db.delete(storeName, key);
}

// Clear all data from a specific store
export async function clearDB(storeName) {
    const db = await setupDB(storeName);
    await db.clear(storeName);
}
